import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  standalone: false,
  template: `
    <div class="paginator">
      @if (showCurrentPageReport) {
        <span class="paginator-info">{{ pageReport }}</span>
      }
      <div class="paginator-controls">
        <button class="paginator-btn" [disabled]="isFirstPage" (click)="goToPage(0)" title="Erste Seite">
          <i class="pi pi-angle-double-left"></i>
        </button>
        <button class="paginator-btn" [disabled]="isFirstPage" (click)="goToPage(currentPage - 1)" title="Vorherige Seite">
          <i class="pi pi-angle-left"></i>
        </button>
        <span class="paginator-pages">{{ currentPage + 1 }} / {{ totalPages || 1 }}</span>
        <button class="paginator-btn" [disabled]="isLastPage" (click)="goToPage(currentPage + 1)" title="Nächste Seite">
          <i class="pi pi-angle-right"></i>
        </button>
        <button class="paginator-btn" [disabled]="isLastPage" (click)="goToPage(totalPages - 1)" title="Letzte Seite">
          <i class="pi pi-angle-double-right"></i>
        </button>
      </div>
      @if (rowsPerPageOptions && rowsPerPageOptions.length > 0) {
        <select class="paginator-select" [value]="rows" (change)="onRowsChange($event)">
          @for (opt of rowsPerPageOptions; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      }
    </div>
  `
})
export class PaginatorComponent {
  @Input() totalRecords = 0;
  @Input() rows = 10;
  @Input() rowsPerPageOptions: number[] = [];
  @Input() first = 0;
  @Input() showCurrentPageReport = false;
  @Input() currentPageReportTemplate = '';

  @Output() pageChange = new EventEmitter<{ first: number; rows: number }>();

  get currentPage(): number {
    return this.rows > 0 ? Math.floor(this.first / this.rows) : 0;
  }

  get totalPages(): number {
    return this.rows > 0 ? Math.ceil(this.totalRecords / this.rows) : 0;
  }

  get isFirstPage(): boolean {
    return this.currentPage === 0;
  }

  get isLastPage(): boolean {
    return this.currentPage >= this.totalPages - 1;
  }

  get pageReport(): string {
    if (this.currentPageReportTemplate) {
      const first = this.first + 1;
      const last = Math.min(this.first + this.rows, this.totalRecords);
      return this.currentPageReportTemplate
        .replace('{first}', String(first))
        .replace('{last}', String(last))
        .replace('{totalRecords}', String(this.totalRecords))
        .replace('{currentPage}', String(this.currentPage + 1))
        .replace('{totalPages}', String(this.totalPages));
    }
    return `${this.first + 1} - ${Math.min(this.first + this.rows, this.totalRecords)} von ${this.totalRecords}`;
  }

  goToPage(page: number): void {
    if (page < 0 || page >= this.totalPages) return;
    this.first = page * this.rows;
    this.pageChange.emit({ first: this.first, rows: this.rows });
  }

  onRowsChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.rows = +select.value;
    this.first = 0;
    this.pageChange.emit({ first: this.first, rows: this.rows });
  }
}
